import React from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

// A +/- stepper for the TV layout settings. On a Firestick (and other remote-
// driven browsers) a `type="number"` field is unusable: the on-screen keyboard
// can only append digits to the controlled value, so you get stuck at 1, 10,
// 11… and can never reach a single digit 2–9. Big focusable buttons let the
// remote step the value directly, no keyboard involved.
export default function TvNumberStepper({
  label,
  helperText,
  value,
  onChange,
  min = 1,
  max = 999,
  step = 1,
}) {
  const clamp = (n) => Math.max(min, Math.min(max, n));
  const dec = () => onChange(clamp(Number(value) - step));
  const inc = () => onChange(clamp(Number(value) + step));

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        {label}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1}>
        <IconButton
          onClick={dec}
          disabled={Number(value) <= min}
          aria-label={`Decrease ${label}`}
          sx={{ border: 1, borderColor: "divider", borderRadius: 1 }}
        >
          <RemoveIcon />
        </IconButton>

        <Typography
          variant="h6"
          sx={{ minWidth: 48, textAlign: "center", fontVariantNumeric: "tabular-nums" }}
        >
          {value}
        </Typography>

        <IconButton
          onClick={inc}
          disabled={Number(value) >= max}
          aria-label={`Increase ${label}`}
          sx={{ border: 1, borderColor: "divider", borderRadius: 1 }}
        >
          <AddIcon />
        </IconButton>
      </Stack>
      {helperText && (
        <Typography variant="caption" sx={{ opacity: 0.7 }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
}
